module.exports = __webpack_public_path__ + "../assets/img/fold1.37bf9d0f.png";